import React, { useEffect, useState } from 'react';

const LoadingScreen = ({ onComplete }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Start fade out after 3.5 seconds (before 4 seconds to allow smooth transition)
    const fadeTimer = setTimeout(() => {
      setIsVisible(false);
    }, 3500);

    // Complete loading after 4 seconds
    const completeTimer = setTimeout(() => {
      onComplete();
    }, 4000);

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(completeTimer);
    };
  }, [onComplete]);

  return (
    <div
      className={`fixed inset-0 z-[9999] flex items-center justify-center transition-opacity duration-500 ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`}
      style={{
        background: 'linear-gradient(135deg, #6b21a8 0%, #7c3aed 50%, #8b5cf6 100%)',
      }}
    >
      {/* Subtle background pattern */}
      <div
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage: `radial-gradient(circle at 20% 50%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
                           radial-gradient(circle at 80% 80%, rgba(255, 255, 255, 0.08) 0%, transparent 50%)`,
        }}
      ></div>

      {/* Logo container */}
      <div className="relative z-10 flex flex-col items-center justify-center px-4">
        {/* Pulsing glow effect behind logo */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-64 h-64 bg-white/20 rounded-full blur-3xl animate-pulse-slow"></div>
        </div>

        {/* Logo */}
        <div className="relative animate-pulse-gentle">
          <img
            src="https://customer-assets.emergentagent.com/job_wanda-for-kissimmee/artifacts/aax9kmpd_IMG_7910%20%281%29logo.png"
            alt="Wanda Roman Campaign"
            className="h-32 sm:h-40 md:h-48 w-auto object-contain drop-shadow-2xl"
          />
        </div>

        {/* Tagline */}
        <p className="mt-8 text-white/90 text-lg sm:text-xl md:text-2xl font-semibold italic animate-fade-in-up">
          Leadership. Community. Progress.
        </p>
      </div>

      {/* Loading indicator dots */}
      <div className="absolute bottom-16 left-1/2 transform -translate-x-1/2 flex space-x-2">
        <div className="w-2 h-2 bg-white/60 rounded-full animate-bounce-delay-0"></div>
        <div className="w-2 h-2 bg-white/60 rounded-full animate-bounce-delay-1"></div>
        <div className="w-2 h-2 bg-white/60 rounded-full animate-bounce-delay-2"></div>
      </div>
    </div>
  );
};

export default LoadingScreen;
